module.exports = __webpack_public_path__ + "static/media/cash.dfd438bf.svg";